export const loginRepository = {
  header: 'BRIBrain Login',
  title: "Login",
  description: `Yuk, login dulu untuk menggunakan BRIBrain!`,
  personal_number: {
    label: 'Personal Number atau Email',
    placeholder: 'Masukkan personal number atau email kerja Anda',
    max: process.env.BRIBRAIN_ENV === 'localhost' ? 8 : 30,
  },
  email: {
    label: 'Email',
    placeholder: 'Masukkan email Anda',
    max: 254,
  },
  password: {
    label: 'Password',
    placeholder: 'Masukkan password',
    max: 30,
  },
  captcha: {
    label: 'Captcha',
    placeholder: 'Masukkan kode captcha',
    max: 30,
  },
  login_button: {
    loading_text: 'Mohon Tunggu',
    default_text: 'LOGIN',
    type: 'submit',
    variant: 'primary',
    size: 'wide',
  },
};
